"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableContractsModule = void 0;
var date_helper_const_1 = require("@const/date-helper.const");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var translation_1 = __importDefault(require("@services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = require("lodash");
var fitpos_api_1 = require("../../../api/fitpos-api");
var data_processing_service_1 = require("../services/data-processing.service");
var open_api_service_1 = require("../services/open-api.service");
var recaptcha_token_service_1 = require("../services/recaptcha-token.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var AvailableContractsModule = /** @class */ (function () {
    function AvailableContractsModule() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.fitposAPI = object_service_1.ObjectService.getInstance(fitpos_api_1.FitposApi);
        //private contractModule = _AllModules.checkout;
        //private modulesModule = _AllModules.modules;
        this.settingsService = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
        this.openApiService = object_service_1.ObjectService.getInstance(open_api_service_1.OpenApiService);
        this.recaptchaTokenService = object_service_1.ObjectService.getInstance(recaptcha_token_service_1.RecaptchaTokenService);
        this.offerings = [];
        this.contracts = [];
        this.disallowPurchase = false;
    }
    AvailableContractsModule.prototype.dataHidePressed = function (section) {
        if (section === 'modules') {
            //this.modulesModule.instance['resetSelectedModules']();
        }
    };
    AvailableContractsModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var _ActionMapping, _a, overWriteSettings;
            var _this = this;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.moduleDiv = moduleDiv;
                        this.customer = customer;
                        this.section =
                            moduleDiv.getAttribute('data-module') === 'available-modules'
                                ? 'modules'
                                : 'checkout';
                        if (!(this.section === 'checkout')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.recaptchaTokenService.loadReCaptcha()];
                    case 1:
                        _d.sent();
                        _d.label = 2;
                    case 2:
                        _ActionMapping = {
                            submit: function () { return _this.submitInputs(); },
                        };
                        _a = this;
                        return [4 /*yield*/, this.fitposAPI.getCustomerContractData(customer.id, 'ACTIVE')];
                    case 3:
                        _a.contracts = _d.sent();
                        (0, cash_dom_1.default)('[data-reset="true"]').on('click', function (event) {
                            event.preventDefault();
                            event.stopPropagation();
                            _this.dataHidePressed(_this.section);
                        });
                        this.dataProcessing.mapDataAction(moduleDiv, _ActionMapping);
                        if (this.contracts.length > 1) {
                            //currently multiple contracts are not compatible with our ui
                            alert('Entschuldige, aber aktuell können wir die Funktion nicht bei mehreren Verträgen anbieten.');
                            moduleDiv
                                .querySelectorAll('[data-action="submit"]')
                                .forEach(function (a) { return (a['style'].background = 'gray'); });
                            this.disallowPurchase = true;
                        }
                        overWriteSettings = __assign(__assign({}, this.config.get), { refObjectId: this.config.get.fitpos.refObjectAvailableContracts, section: this.section });
                        if (this.section === 'checkout') {
                            overWriteSettings.checkout = __assign(__assign({}, (((_b = this.config.get) === null || _b === void 0 ? void 0 : _b.checkout) || {})), { noRedirect: true, callback: function (obj) {
                                    _this.offerings = obj.offerings;
                                    _this.selectedTerm = obj.selectedTerm;
                                    _this.selectedOffering = obj.selectedOffering;
                                    (0, cash_dom_1.default)(_this.moduleDiv)
                                        .find('[data-show="onTermSelected"]')
                                        .css('display', '');
                                    _this.updateDataGets();
                                } });
                            this.settingsService.set = overWriteSettings;
                            //this.contractModule.instance.$container = $(moduleDiv);
                            //this.contractModule.instance.loadModule();
                        }
                        else if (this.section === 'modules') {
                            overWriteSettings.modules = __assign(__assign({ noRedirect: true }, (((_c = this.config.get) === null || _c === void 0 ? void 0 : _c.modules) || {})), { callback: function (modules) {
                                    console.error(modules);
                                    _this.selectedTerm = modules.selectedTerm;
                                    (0, cash_dom_1.default)('[data-show="onModuleSelected"]').css('display', '');
                                    var totalPrice = 0;
                                    (0, cash_dom_1.default)('[data-get]').each(function (a, b) {
                                        var path = b.getAttribute('data-get');
                                        if (path === 'totalPrice') {
                                            var _loop_1 = function (moduleId) {
                                                var price = modules.allModules.find(function (a) { return a.id === moduleId; });
                                                totalPrice += +price.price;
                                            };
                                            for (var _i = 0, _a = modules.optionalModules; _i < _a.length; _i++) {
                                                var moduleId = _a[_i];
                                                _loop_1(moduleId);
                                            }
                                            b.innerHTML = translation_1.default.transformCurrency(totalPrice) + '€';
                                        }
                                    });
                                } });
                            this.settingsService.set = overWriteSettings;
                            //this.modulesModule.instance.$container = $(moduleDiv);
                            //this.modulesModule.instance.loadModule();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AvailableContractsModule.prototype.updateDataGets = function () {
        var _this = this;
        (0, cash_dom_1.default)(this.moduleDiv)
            .find('[data-get]')
            .not((0, cash_dom_1.default)(this.moduleDiv).find('[data-module] [data-get]'))
            .each(function (a, b) {
            var path = b.getAttribute('data-get');
            if ((0, lodash_1.get)(_this.selectedTerm, path)) {
                if (path === 'price') {
                    b.innerHTML =
                        translation_1.default.transformCurrency((0, lodash_1.get)(_this.selectedTerm, path)) + '€';
                }
                else {
                    b.innerHTML = translation_1.default.t((0, lodash_1.get)(_this.selectedTerm, path));
                }
            }
        });
    };
    AvailableContractsModule.prototype.submitInputs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var performSubmit, token, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (this.disallowPurchase) {
                            alert('Entschuldige, aber aktuell können wir die Funktion nicht bei mehreren Verträgen anbieten.');
                            return [2 /*return*/];
                        }
                        performSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
                            var freeModules, paidModules, _i, _a, key;
                            var _this = this;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        freeModules = [];
                                        paidModules = [];
                                        if (!(this.section === 'modules')) return [3 /*break*/, 1];
                                        for (_i = 0, _a = ['selectableModules', 'optionalModules']; _i < _a.length; _i++) {
                                            key = _a[_i];
                                            if (localStorage.getItem(key)) {
                                                freeModules = JSON.parse(localStorage.getItem(key)).map(function (a) { return ({
                                                    id: a,
                                                }); });
                                            }
                                        }
                                        return [3 /*break*/, 3];
                                    case 1:
                                        console.log('customer & contract', this.customer, this.contracts);
                                        return [4 /*yield*/, this.openApiService.cancelContractExtraordinary(this.token, this.customer, this.contracts[0])];
                                    case 2:
                                        _c.sent();
                                        _c.label = 3;
                                    case 3:
                                        (0, generator_const_1._CreateLoadingScreen)();
                                        return [4 /*yield*/, this.openApiService.createNewContract(this.customer, this.config.get.studioId, {
                                                rateBundleTermId: this.selectedTerm.id,
                                                startDate: (0, date_helper_const_1._GetUserLocalTime)().toISOString().replace(/T.*/, ''),
                                                selectedRateBundleModules: freeModules,
                                                optionalRateBundleTermModules: paidModules,
                                            })];
                                    case 4:
                                        _c.sent();
                                        if ((_b = this.config.get) === null || _b === void 0 ? void 0 : _b.redirect) {
                                            setTimeout(function () {
                                                (0, generator_const_1._DeleteLoadingScreen)();
                                                window.location.href = _this.config.get.redirect;
                                            }, 3000);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        if (!(!this.token && this.section === 'checkout')) return [3 /*break*/, 2];
                        console.error('Token is not ready trying captcha again');
                        return [4 /*yield*/, this.recaptchaTokenService.renderReCaptcha()];
                    case 1:
                        token = _a.sent();
                        if (token === null || token === void 0 ? void 0 : token.length) {
                            this.token = token;
                        }
                        else {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, performSubmit()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return AvailableContractsModule;
}());
exports.AvailableContractsModule = AvailableContractsModule;
